import React from 'react'
import { Controller, Control, FieldErrors } from 'react-hook-form'
import BaseQuestion from '../../base-question'
import SurveyHeightPicker from './height-picker'

interface HeightQuestionProps {
  question: {
    id: number | string
    text: string
    isRequired?: boolean
    type: string
  }
  // RHF mode
  control?: Control<any>
  errors?: FieldErrors<any>
  // Zustand mode
  value?: string | number
  error?: string
  onChange?: (value: string) => void
}

const HeightQuestion: React.FC<HeightQuestionProps> = ({
  question,
  control,
  errors,
  value,
  error,
  onChange,
}) => {
  const isRHFMode = !!control && !!errors
  const questionId =
    typeof question.id === 'string' ? parseInt(question.id, 10) : question.id

  if (isRHFMode) {
    // RHF mode - use Controller
    return (
      <BaseQuestion
        question={{
          ...question,
          id: questionId,
        }}
        control={control}
        errors={errors}>
        <Controller
          name={`question_${question.id}`}
          control={control}
          rules={{
            required: question.isRequired ? 'This field is required' : false,
          }}
          render={({ field }) => {
            // Parse the stored value (total inches as string or number)
            const totalInches =
              field.value !== undefined && field.value !== null
                ? parseInt(String(field.value), 10)
                : undefined

            return (
              <SurveyHeightPicker
                inches={totalInches}
                onChange={(totalInches: number) => {
                  // Store as string (matching existing format)
                  field.onChange(String(totalInches))
                }}
              />
            )
          }}
        />
      </BaseQuestion>
    )
  } else {
    // Zustand mode - use direct props
    const totalInches =
      value !== undefined && value !== null
        ? parseInt(String(value), 10)
        : undefined

    return (
      <BaseQuestion
        question={{
          ...question,
          id: questionId,
        }}
        error={error}>
        <SurveyHeightPicker
          inches={totalInches}
          onChange={(totalInches: number) => {
            // Store as string (matching existing format)
            onChange?.(String(totalInches))
          }}
        />
      </BaseQuestion>
    )
  }
}

export default HeightQuestion
